import { useQuery } from "@tanstack/react-query";
import {
  deleteUser,
  GetUsers,
  getUsers,
  LocationsProvinceId,
  LocationsProvinces,
  ScannerRequirement,
  UserStatistics,
} from "../../services/services";
import ResponsiveDataList from "../../components/ResponsiveDataList/ResponsiveDataList";
import { useEffect, useMemo, useState } from "react";
import { LeagueFormatter } from "../../components/LeagueFormatter/LeagueFormatter";
import { booleanFormatter } from "../../formatters/booleanFormatter";
import Loading from "../../components/Loading/Loading";
import { moreSvg } from "../../svg/more";
import { editSvg } from "../../svg/edit.svg";
import CloseRedIconSvg from "../../svg/CloseRedIconSvg";
import { Link } from "react-router-dom";
import InformationSmallBanner from "../../components/InformationSmallBanner/InformationSmallBanner";
import applicationSvg from "../../svg/application.svg";
import usersSvg from "../../svg/users.svg";
import activeSvg from "../../svg/active.svg";
import uniqueSvg from "../../svg/unique.svg";
import ModalEditUser from "./ModalEditUser";
import ModalSendMessageUser from "./ModalSendMessageUser";
import ModalChargeWithCode from "./ModalChargeWithCode";
import { SelectCustom } from "../../components/SelectCustom/SelectCustom";
import PersianDate from "../../components/PersianDate/PersianDate";
import TextField from "../../components/Textfield/TextField";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useResponsivePageSize } from "../../hook/useResponsivePageSize";
import useSyncPageSize from "../../hook/useSyncPageSize";
import { URLs } from "../../constants/urls";
import ModalSendCoin from "./ModalSendCoin";
import ModalScanner from "./ModalScanner";
import colors from "react-multi-date-picker/plugins/colors";

const UsersList = () => {
  const pageSize = useResponsivePageSize();
  const location = useLocation();
  const history = useHistory();
  const getFiltersFromUrl = () => {
    const parsed = queryString.parse(location.search);
    return {
      Id: parsed.Id ?? undefined,
      Name: parsed.Name ?? "",
      PhoneNumber: parsed.PhoneNumber ?? "",
      OrderBy: parsed.OrderBy ?? "",
      pageNumber: Number(parsed.pageNumber) || 1,
      IsActiveUsers: false,
      IsInactiveForOneYear: false,
      IsJoinedThisMonth: false,
      UserProvinceId: parsed.UserProvinceId ?? undefined,
      UserCityId: parsed.UserCityId ?? undefined,
      pageSize: Number(parsed.pageSize) || pageSize,
      IsAscending:
        parsed.IsAscending === "true"
          ? true
          : parsed.IsAscending === "false"
          ? false
          : undefined,
    };
  };

  const [filters, setFilters] = useState(getFiltersFromUrl());
  const [tempFilters, setTempFilters] = useState(filters);
  const [editUser, setEditUser] = useState();
  const [editUserModal, setEditUserModal] = useState(false);
  const [modalSendMessage, setModalSendMessage] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [userIdList, setUserIdList] = useState([]);
  const [showModalScanner, setShowModalScanner] = useState(false);
  const [showModalSendCoin, setShowModalSendCoin] = useState(false);
  useSyncPageSize(filters, setFilters, pageSize);

  useEffect(() => {
    const query = queryString.stringify(filters, {
      skipNull: true,
      skipEmptyString: true,
    });
    history.replace({ search: `?${query}` });
  }, [filters]);

  const { data: listUsers, refetch } = useQuery({
    queryKey: ["GetUsers", filters],
    queryFn: () => GetUsers(filters),
    select: (res) => res,
    enabled: !!filters,
    staleTime: 60 * 60000,
    retry: false,
  });

  const { data: userStatistics } = useQuery({
    queryKey: ["UserStatistics"],
    queryFn: () => UserStatistics(),
    select: (res) => res,
    staleTime: 60 * 60000,
    retry: false,
  });

  const asArray = (v) => (Array.isArray(v) ? v : []);

  const { data: provincesRaw } = useQuery({
    queryKey: ["LocationsProvinces"],
    queryFn: () => LocationsProvinces(),
    retry: false,
    staleTime: 30 * 60 * 1000,
  });
  const provinces = useMemo(() => asArray(provincesRaw), [provincesRaw]);

  const { data: cityRes } = useQuery({
    queryKey: ["LocationsProvinceId", tempFilters?.UserProvinceId],
    queryFn: () => LocationsProvinceId(tempFilters?.UserProvinceId),
    select: (res) => res,
    retry: false,
    enabled: !!tempFilters?.UserProvinceId,
  });
  const city = cityRes?.cities ?? [];

  const handleSearch = () => {
    setFilters(tempFilters);
    refetch();
  };
  const sortOrderBy = [
    {
      label: `${
        tempFilters.OrderBy == "registerTime" ? "جدیدترین" : "بیشترین"
      }`,
      value: "false",
    },
    {
      label: `${
        tempFilters.OrderBy == "registerTime" ? "قدیمی ترین" : "کمترین"
      }`,
      value: "true",
    },
  ];

  const columns = [
    {
      field: "id",
      header: "شناسه",
      style: {
        textAlign: "right",
      },
    },
    {
      field: "fullName",
      header: "نام",
      style: {
        textAlign: "right",
      },
    },
    {
      field: "phoneNumber",
      header: "شماره موبایل",
      style: { textAlign: "right" },
    },
    // {
    //   field: "ibanCode",
    //   header: "کد ملی",
    //   style: { textAlign: "right" },
    // },
    {
      field: "provinceName",
      header: "استان",
      style: { textAlign: "right" },
    },
    {
      field: "userCityName",
      header: "شهر",
      style: { textAlign: "right" },
    },
    {
      field: "lastOtpCode",
      body: (rowData) => <PersianDate date={rowData?.registerTime} />,
      header: "تاریخ ثبت نام",
      style: { textAlign: "right" },
    },
    {
      field: "balance",
      header: "تعداد سکه",
      style: { textAlign: "right" },
    },
    {
      field: "installaitionCount",
      header: "تعداد نصب",
      headerClassName: "custom-sortable-column",
      style: { textAlign: "right" },
    },
    {
      body: (rowData) => LeagueFormatter(rowData.league),
      header: "لیگ",
      style: { textAlign: "right" },
    },

    {
      field: "chargeCount",
      header: "تعداد شارژ",
      headerClassName: "custom-sortable-column",
      style: { textAlign: "right" },
    },
    {
      field: "isScannerRequired",
      body: (rowData) => (rowData.isScannerRequired ? "فعال" : "غیر فعال"),
      header: " وضعیت اسکنر ",
      headerClassName: "custom-sortable-column",
      style: { textAlign: "right" },
    },

    {
      header: "جزئیات",
      body: (rowData) => (
        <Link
          className="mx-1 cursor-pointer"
          to={`/user-information?userId=${rowData.id}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            backgroundColor: "rgb(99, 99, 99)",
            height: "16px",
            with: "10px",
            borderRadius: "8px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {moreSvg()}
        </Link>
      ),
      style: { textAlign: "right" },
    },
    {
      field: "mustInstalledName",
      header: " بیشترین تابلو نصب شده‌  ",
      headerClassName: "custom-sortable-column",
      style: { textAlign: "right" },
    },
  ];

  const itemTemplate = (item) => (
    <div
      key={item.id}
      className="card shadow-sm mb-3 p-3"
      style={{
        backgroundColor: "#f9f9f9",
        border: "1px solid #eee",
        direction: "rtl",
      }}
    >
      <div className="d-flex justify-content-between mb-1">
        <strong>شناسه:</strong>
        <span>{item.id}</span>
      </div>
      <hr />
      <div className="mb-1">
        <strong>نام:</strong> {item.fullName}
      </div>
      <div className="mb-1">
        <strong>تاریخ:</strong>
        <PersianDate date={item.lastOtpCode} />
      </div>
      <div className="mb-1">
        <strong>شماره موبایل:</strong> {item.phoneNumber}
      </div>
      <div className="mb-1">
        <strong> شهر:</strong> {item.city}
      </div>
      <div className="mb-1">
        <strong> استان:</strong> {item.state}
      </div>
      <div className="mb-1">
        <strong> آدرس:</strong> {item.address}
      </div>
      <div className="mb-1">
        <strong> سکه:</strong> {item.score}
      </div>
      <div className="mb-1">
        <strong> تعداد نصب:</strong> {item.installCount}
      </div>
      <div className="mb-1">
        <strong> تعداد شارژ:</strong> {item.chargeCount}
      </div>
      {/* <div className="mb-1">
        <strong> تعداد رفرال:</strong> {item.ReferralCount}
      </div> */}
      <div className="mb-1">
        <strong> لیگ:</strong> {LeagueFormatter(item.league)}
      </div>
      {/* <div className="mb-1">
        <strong> رفرال موفق:</strong> {item.SuccessfulReferralCount}
      </div> */}
      <div className="mb-1">
        <strong> تکمیل اطلاعات :</strong> {booleanFormatter(item.registered)}
      </div>
      {/* <div className="mb-1">
        <strong> کد معرف:</strong> {item.RefrenceID}
      </div> */}
      <hr />
      <div className="d-flex justify-content-between">
        <Link
          className=" mx-1"
          to={URLs.USER_INFORMATION + `?userId=${item.id}`}
        >
          {moreSvg()}
        </Link>
        <div
          className="cursor-pointer"
          onClick={() => {
            setEditUserModal(true);
            setEditUser(item);
          }}
        >
          {editSvg({ width: "16px" })}
        </div>
        <div
          className="cursor-pointer"
          // onClick={() => deleteUser(item.id).then(() => refetch())}
        >
          <CloseRedIconSvg style={{ width: "20px", height: "20px" }} />
        </div>
      </div>
    </div>
  );

  const orderByOptions = [
    { label: "تاریخ ثبت نام", value: "registerTime" },
    { label: "تعداد سکه", value: "balance" },
    { label: "تعداد نصب", value: "installaitionCount" },
  ];

  const provincesOptions = useMemo(
    () => provinces.map((p) => ({ value: p.id, label: p.name })),
    [provinces]
  );

  const selectedProvince = useMemo(
    () =>
      provincesOptions.find((o) => o.value === tempFilters?.UserProvinceId) ??
      null,
    [provincesOptions, tempFilters?.UserProvinceId]
  );

  const citiesOptions = useMemo(
    () => city.map((c) => ({ value: c.id, label: c?.name })),
    [city]
  );

  const selectedCity = useMemo(
    () =>
      citiesOptions.find((o) => o.value === tempFilters?.UserCityId) ?? null,
    [citiesOptions, tempFilters?.UserCityId]
  );

  return (
    <div className="list-user">
      {(listUsers?.items == undefined || userStatistics == undefined) && (
        <Loading />
      )}
      <div>
        <div className="row">
          <div
            className="col-6 col-xl-3 col-md-5 mt-xl-0 mt-2"
            title="تعداد تمام کاربران اپلیکیشن"
            onClick={() => {
              setFilters({
                ...filters,
                IsActiveUsers: false,
                IsInactiveForOneYear: false,
                IsJoinedThisMonth: false,
              });
              setTempFilters({
                ...tempFilters,
                IsActiveUsers: false,
                IsInactiveForOneYear: false,
                IsJoinedThisMonth: false,
              });
            }}
          >
            <InformationSmallBanner
              title={" تعداد کاربران اپلیکیشن "}
              svg={usersSvg({
                width: "60px",
                height: "60px",
                fill: "#fff",
              })}
              value={userStatistics?.totalUsersCount || 0}
              fontSizeCount="30px"
              background={`${
                filters?.IsActiveUsers == false &&
                filters?.IsInactiveForOneYear == false &&
                filters?.IsJoinedThisMonth == false
                  ? "linear-gradient(to bottom right,rgba(134, 160, 255, 0.82), #434ce6)"
                  : "rgb(100, 100, 100)"
              }`}
            />
          </div>

          <div
            className="col-6 col-xl-3 col-md-5 mt-xl-0 mt-2"
            title="تعداد کاربرانی که در سال جاری نصب داشته اند"
            onClick={() => {
              setFilters({
                ...filters,
                IsActiveUsers: true,
                IsInactiveForOneYear: false,
                IsJoinedThisMonth: false,
              });
              setTempFilters({
                ...tempFilters,
                IsActiveUsers: true,
                IsInactiveForOneYear: false,
                IsJoinedThisMonth: false,
              });
            }}
          >
            <InformationSmallBanner
              title={" کاربران فعال امسال "}
              svg={activeSvg({
                width: "60px",
                height: "60px",
                fill: "#fff",
              })}
              fontSizeCount="30px"
              value={userStatistics?.activeUsersCount || 0}
              background={`${
                filters?.IsActiveUsers == true &&
                filters?.IsInactiveForOneYear == false &&
                filters?.IsJoinedThisMonth == false
                  ? "linear-gradient(to bottom right,rgba(134, 160, 255, 0.82), #434ce6)"
                  : "rgb(100, 100, 100)"
              }`}
            />
          </div>
          <div
            className="col-6 col-xl-3 col-md-5 mt-xl-0 mt-2"
            title="تعداد کاربرانی که بیش از یکسال است که غیر فعال هستند و نصبی انجام ندادند"
            onClick={() => {
              setFilters({
                ...filters,
                IsActiveUsers: false,
                IsInactiveForOneYear: true,
                IsJoinedThisMonth: false,
              });
              setTempFilters({
                ...tempFilters,
                IsActiveUsers: false,
                IsInactiveForOneYear: true,
                IsJoinedThisMonth: false,
              });
            }}
          >
            <InformationSmallBanner
              title={"کاربران غیر فعال"}
              svg={applicationSvg({
                width: "60px",
                height: "60px",
                fill: "#fff",
              })}
              value={userStatistics?.inactiveForOneYearCount || 0}
              fontSizeCount="30px"
              background={`${
                filters?.IsActiveUsers == false &&
                filters?.IsInactiveForOneYear == true &&
                filters?.IsJoinedThisMonth == false
                  ? "linear-gradient(to bottom right,rgba(134, 160, 255, 0.82), #434ce6)"
                  : "rgb(100, 100, 100)"
              }`}
            />
          </div>
          <div
            className="col-6 col-xl-3 col-md-5 mt-xl-0 mt-2"
            title="کاربران جدید این ماه که در اپلیکیشن به تازگی ثبت نام کردند"
            onClick={() => {
              setFilters({
                ...filters,
                IsActiveUsers: false,
                IsInactiveForOneYear: false,
                IsJoinedThisMonth: true,
              });
              setTempFilters({
                ...tempFilters,
                IsActiveUsers: false,
                IsInactiveForOneYear: false,
                IsJoinedThisMonth: true,
              });
            }}
          >
            <InformationSmallBanner
              title={" کاربران جدید ماه "}
              svg={uniqueSvg({
                width: "60px",
                height: "60px",
                fill: "#fff",
              })}
              value={userStatistics?.joinedThisMonthCount || 0}
              fontSizeCount="30px"
              background={`${
                filters?.IsActiveUsers == false &&
                filters?.IsInactiveForOneYear == false &&
                filters?.IsJoinedThisMonth == true
                  ? "linear-gradient(to bottom right,rgba(134, 160, 255, 0.82), #434ce6)"
                  : "rgb(100, 100, 100)"
              }`}
            />
          </div>
        </div>
      </div>
      <div className=" card mt-3">
        {filters?.IsActiveUsers == false &&
        filters?.IsInactiveForOneYear == false &&
        filters?.IsJoinedThisMonth == false ? (
          <h5>فهرست کاربران</h5>
        ) : filters?.IsActiveUsers == true &&
          filters?.IsInactiveForOneYear == false &&
          filters?.IsJoinedThisMonth == false ? (
          <h5>فهرست کاربران فعال</h5>
        ) : filters?.IsActiveUsers == false &&
          filters?.IsInactiveForOneYear == true &&
          filters?.IsJoinedThisMonth == false ? (
          <h5>فهرست کاربران غیر فعال</h5>
        ) : (
          <h5>فهرست کاربران جدید در این ماه</h5>
        )}

        <div className="background-dataTable">
          <div className="row mt-2">
            {/* <div className="col-12 col-xl-2 col-md-5 mt-md-0 mt-2">
              <TextField
                style={{ height: "40px" }}
                value={tempFilters.Id}
                label={"شناسه"}
                onChange={(e) =>
                  setTempFilters({ ...tempFilters, Id: e.target.value })
                }
              />
            </div> */}
            <div className="col-12 col-xl-2 col-md-5 mt-md-0 mt-2">
              <TextField
                style={{ height: "40px" }}
                value={tempFilters.Name}
                label={"نام"}
                onChange={(e) =>
                  setTempFilters({ ...tempFilters, Name: e.target.value })
                }
              />
            </div>
            <div className="col-12 col-xl-2 col-md-5 mt-md-0 mt-2">
              <TextField
                style={{ height: "40px" }}
                value={tempFilters.PhoneNumber}
                label={"شماره تلفن"}
                onChange={(e) =>
                  setTempFilters({
                    ...tempFilters,
                    PhoneNumber: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-12 col-xl-2 col-md-5 mt-md-0 mt-2">
              <SelectCustom
                placeholder="استان"
                isClearable
                isSearchable
                unstyled
                options={provincesOptions}
                value={selectedProvince}
                onChange={(e) => {
                  setTempFilters({
                    ...tempFilters,
                    UserProvinceId: e ? e.value : null,
                    UserCityId: null,
                  });
                }}
              />
            </div>
            <div className="col-12 col-xl-2 col-md-5 mt-md-0 mt-2">
              <SelectCustom
                placeholder="شهر"
                isClearable
                isSearchable
                unstyled
                options={citiesOptions}
                value={selectedCity}
                onChange={(e) => {
                  setTempFilters({
                    ...tempFilters,
                    UserCityId: e ? e.value : null,
                  });
                }}
              />
            </div>
            <div className="col-12 col-xl-2 col-md-5 mt-md-0 mt-2">
              <SelectCustom
                name="OrderBy"
                placeholder="مرتب کردن بر اساس"
                isClearable={true}
                isSearchable={false}
                unstyled={true}
                options={orderByOptions}
                value={
                  orderByOptions.find(
                    (item) => item.value === tempFilters.OrderBy
                  ) || null
                }
                onChange={(e) => {
                  setTempFilters({
                    ...tempFilters,
                    OrderBy: e ? e.value : null,
                  });
                }}
              />
            </div>
            {tempFilters.OrderBy && (
              <div className="col-12 col-xl-2 col-md-5 mt-md-0 mt-2">
                <SelectCustom
                  name="IsAscending"
                  isClearable={true}
                  isSearchable={false}
                  unstyled={true}
                  options={sortOrderBy}
                  value={
                    sortOrderBy.find(
                      (item) => item.value === tempFilters.IsAscending
                    ) || null
                  }
                  onChange={(e) => {
                    setTempFilters({
                      ...tempFilters,
                      IsAscending: e ? e.value : null,
                    });
                  }}
                />
              </div>
            )}
            <div className="col-6 col-xl-2 col-md-5 d-flex align-items-end mt-md-0 mt-2">
              <button
                style={{
                  color: "#ffff",
                  background: "#86a0ff",
                  border: "0px",
                  width: "108px",
                  height: "39px",
                  borderRadius: "8px",
                  padding: "2px",
                }}
                onClick={handleSearch}
              >
                جستجو
              </button>
            </div>
          </div>

          <ResponsiveDataList
            data={listUsers?.items}
            columns={columns}
            itemTemplate={itemTemplate}
            dataViewHeader={<></>}
            selection={selectedUsers}
            onSelectionChange={(e) => {
              setSelectedUsers(e.value);
              setUserIdList(e.value.map((u) => u.id));
            }}
            dataKey="id"
            className="farsi-monospace-digit"
            rows={filters.pageSize}
            pageNumber={filters.pageNumber}
            totalCount={listUsers?.totalCount}
            enableSelection={true}
            selectOnCardClick={true}
            onPageChange={({ pageNumber }) => {
              setFilters((prev) => ({
                ...prev,
                pageNumber,
              }));
            }}
            typeFilter={true}
          />
        </div>
      </div>
      <ModalEditUser
        editUser={editUser}
        editUserModal={editUserModal}
        setEditUserModal={setEditUserModal}
        setEditUser={setEditUser}
      />
      <div
        className="fixed-footer-buttons"
        style={{
          width: "120px",
        }}
      >
        <button
          className="button2"
          onClick={() => setShowModalScanner(true)}
          disabled={userIdList?.length == 0}
        >
          فعال / غیر فعال اسکنر
        </button>
        <ModalScanner
          showModalScanner={showModalScanner}
          setShowModalScanner={setShowModalScanner}
          userIdList={userIdList}
        />
        <button
          className="button2"
          onClick={() => setShowModalSendCoin(true)}
          disabled={userIdList?.length == 0 || userIdList.length > 1}
        >
          ارسال سکه
        </button>
        <ModalSendCoin
          showModalSendCoin={showModalSendCoin}
          setShowModalSendCoin={setShowModalSendCoin}
          userIdList={userIdList}
        />
        <button
          className="button2"
          onClick={() => setModalSendMessage(true)}
          disabled={userIdList?.length == 0}
        >
          ارسال پیام
        </button>
        <ModalSendMessageUser
          modalSendMessage={modalSendMessage}
          setModalSendMessage={setModalSendMessage}
          userIdList={userIdList}
        />
        {/* <button
          className="button2"
          style={{
            width: "120px",
          }}
          onClick={() => setModalChargeWithCode(true)}
          disabled={selectedUsers.length > 1}
        >
          شارژ
        </button>
        <ModalChargeWithCode
          phoneNumber={selectedUsers[0]?.phoneNumber}
          modalChargeWithCode={modalChargeWithCode}
          setModalChargeWithCode={setModalChargeWithCode}
        /> */}
      </div>
    </div>
  );
};
export default UsersList;
